import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1,
  error: require('../assets/error.jpg'),
  loading: require('../assets/loading.gif'),
  attempt: 1
})
